<!-- FranchisePage.vue -->
<template>
	<div id="AppPage">
		<RootSideBar />
		<div class="app-body">
			<FranchiseAppHeader :user="user" @search="handleSearch" />
			<div class="app-content">
				<router-view :search-query="searchQuery"></router-view>
			</div>
		</div>
	</div>
</template>

<script>
import jwtService from '../services/jwtService';
import RootSideBar from "@/layout/RootSideBar.vue";
import FranchiseAppHeader from "@/layout/FranchiseAppHeader.vue";

export default {
	name: "RootPage",
	components: {
		RootSideBar,
		FranchiseAppHeader,
	},
	data() {
		return {
			user: {},
			searchQuery: "",
		};
	},
	created() {
		this.checkUser();
		this.getUser();
	},
	mounted() {
		jwtService.startTokenExpirationCheck();
	},
	methods: {
		checkUser() {
			const storedType = localStorage.getItem("type");
			if (storedType !== "root" && storedType !== "admin") {
				window.location.href = "/";
			}
		},
		async getUser() {
			try {
				const response = await fetch(process.env.VUE_APP_API_URL + "user/profil", { method: "GET", credentials: "include", });
				const data = await response.json();
				this.isSubmitting = false;
				if (data.error) {
					window.location.href = "/login";
				} else {
					this.user = data;
				}
			} catch (error) {
				console.error("Erreur");
			}
		},
		handleSearch(query) {
			this.searchQuery = query;
		},
	},
};
</script>

<style>
#AppPage {
	display: flex;
}

.app-body {
	width: 100%;
	background-color: #f5f5f5;
}

.app-content {
	padding: 0px 50px 50px;
}

@media (max-width: 950px) {
	.app-content {
		padding: 0px 10px 10px;
	}
}
</style>
